// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const MoonSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.white}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      xmlns="http://www.w3.org/2000/svg"
      fill="#FCFBFC"
      role="presentation"
    >
      <path
        d="M23.64 20.237c-7.11 0-12.877-5.766-12.877-12.88 0-1.528.268-2.995.757-4.357C6.553 4.787 3 9.538 3 15.12 3 22.235 8.766 28 15.88 28c5.582 0 10.333-3.553 12.12-8.52-1.36.49-2.828.757-4.36.757z"
        fillRule="evenodd"
      />
    </svg>
  </SvgContainer>
);
MoonSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default MoonSvg;
